<script setup lang="ts">
import { useBrowserStore } from '@apps/main/new-desktop/core/stores/browserStore';
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppLinkButton, AppSvgIcon } from '@libs/ui';

import PriceGuaranteeSun from './components/PriceGuaranteeSun.vue';

interface HotelDetailsPriceGuaranteeBannerEmits {
  (eventName: 'learn-more'): void;
}
const emit = defineEmits<HotelDetailsPriceGuaranteeBannerEmits>();

const browserStore = useBrowserStore();

const { t } = i18n.global;
</script>

<template>
  <div class="price-guarantee-sun-banner">
    <div class="left-column">
      <div class="price-guarantee-sun-banner-icon">
        <AppSvgIcon
          name="creditCard"
          :size="browserStore.isSmallerThan1200px ? '24' : '36'"
        />
      </div>
    </div>
    <div class="right-column">
      <div class="price-guarantee-sun-banner-header">
        {{ t('price_guarantee.banner.title') }}
      </div>
      <div class="price-guarantee-sun-banner-body">
        <AppLinkButton
          class="price-guarantee-sun-banner-body-button"
          size="m"
          :text="$t('planner.read_more')"
          @click="emit('learn-more')"
        />
      </div>
    </div>
    <PriceGuaranteeSun class="price-guarantee-sun-icon" />
  </div>
</template>

<style scoped lang="scss">
.price-guarantee-sun-banner {
  --icon-circle-size: 48px;
  display: flex;
  gap: var(--spacing-16);
  padding: var(--spacing-24);
  border-radius: var(--border-radius-8);
  position: relative;
  z-index: 0;
  background-color: var(--color-neutral-10);

  @include for-less-or-equal-than-599-px {
    padding: var(--spacing-16);
    --icon-circle-size: 40px;
  }

  .left-column {
    display: flex;
    align-items: center;
    z-index: 1;

    .price-guarantee-sun-banner-icon {
      height: var(--icon-circle-size);
      width: var(--icon-circle-size);
      border-radius: var(--icon-circle-size);
      background-color: var(--color-brand-lilac);

      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }

  .right-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: var(--spacing-8);
    z-index: 1;

    .price-guarantee-sun-banner-header {
      @include font-body-l-bold;

      @include for-less-or-equal-than-599-px {
        @include font-body-m-bold;
      }
    }

    .price-guarantee-sun-banner-body {
      .price-guarantee-sun-banner-body-button {
        @include font-link-l-light;

        @include for-less-or-equal-than-599-px {
          @include font-link-s-light;
        }
      }
    }
  }

  .price-guarantee-sun-icon {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 80%;
    width: auto;
  }
}
</style>
